module.exports = __webpack_public_path__ + "static/media/url_1_105.db14136a.ico";